// extracted by mini-css-extract-plugin
export default {"mainContainer":"Tools_mainContainer__t55B0","items":"Tools_items__hRnzW"};